<template>
    <a>
        <span :uk-icon="'ratio: 1; icon: '+icon" class="uk-icon"></span>
        <span class="uk-text-middle">{{ text }}</span>
    </a>
</template>

<script>
    export default {
        props: {
            icon: String,
            text: String
        }
    }
</script>

<style lang="scss" scoped>
    a:hover {
        text-decoration: none;
    }
</style>